<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="customer_code" :items="customer" item-text="cust_account" item-value="cust_account"
            outlined @change="onSelectCustomerCodeChange(customer_code)" dense label="Client Code"></v-autocomplete>
        </v-col>

        <v-col cols="12" md="8">
          <v-autocomplete v-model="customer_name" :items="customer_list" item-text="name" item-value="id" outlined
            @change="onSelectCustomerChange(customer_name)" dense label="Client Name"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field v-model="invoice_address" outlined dense label="Invoice Address" background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="currency" outlined dense label="Currency" background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field v-model="tax_id" outlined dense label="Tax ID " background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <v-text-field v-model="branch" outlined dense label="Branch" background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field @blur="onSelectpayment()" v-model="payment_term" outlined dense
            label="Payment Term (Day)"></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <v-text-field v-model="vat" @keyup="calvatAll(vat)" @blur="onSelectvat()" outlined dense
            label="Vat (%)"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field @blur="onSelectPONO()" v-model="po_no" outlined dense label="PO NO."></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field @change="onSelectattention()" v-model="attention" outlined dense :disabled="datainv_disable"
            label="Attention"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field @change="onSelectcontact_position()" v-model="contact_position" outlined dense
            :disabled="datainv_disable" label="Contact Position"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select @change="onSelectvat_type()" outlined :items="vat_type_list" v-model="vat_type" item-value="id"
            item-text="name" label="Vat Type" dense></v-select>
        </v-col>
      </v-row>

      <br />

      <template>
        <v-data-table :headers="headers" :items="desserts" class="elevation-1 595959">
          <template v-slot:[`item.unit`]="{ item }">
            <span>
              {{
                item.unit.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>
          <template v-slot:[`item.PricePerUnit`]="{ item }">
            <span>
              {{
                item.PricePerUnit.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>
              {{
                item.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary"> Reset </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon> -->

            <v-icon :style="{
              backgroundColor: '#E1F5FE',
              color: '#2196F3',
            }" :disabled="datainv_disable" @click="openeditItem(item)">
              mdi-pencil
            </v-icon>

            <v-icon class="ml-2" :style="{
              backgroundColor: '#FFEBEE',
              color: '#F44336',
            }" :disabled="datainv_disable" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </template>
      <div v-if="!sostatus" :style="{
        display: !sostatus ? 'show' : 'none',
      }" class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
        <template v-if="
          this.$route.params.customer_id ||
          this.department_name == 'Immigration & Relocation' ||
          this.department_name == 'Intellectual Property'
        ">
          <v-row>
            <v-col cols="12" xl="1" lg="1" md="1" sm="1" style="margin-left: 1rem; padding: 0.5rem 0 0 1rem">
              <v-checkbox label="Header" style="height: 30px" v-model="editedItem.headercheckbox"
                @change="onSelectHeaderChange(editedItem.headercheckbox)"></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="1" md="1"> </v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4" style="padding-right: 0">
              <v-autocomplete :disabled="datainv_disable" v-model="editedItem.inv_title" :items="inv_title_list"
                item-text="title" item-value="title" ref="inv_titleref" label="Select" outlined dense style="width: 97%"
                @change="
                  onSelectmiscellaneous_disbursementsChange(
                    editedItem.inv_title
                  )
                  " @keydown.enter="changeFocusText(2)"></v-autocomplete>
              <!-- <v-text-field
                v-model="editedItem.description"
                ref="txtDescription"
                dense
                outlined
                label="Sevice/Description"
              ></v-text-field> -->
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="padding-left: 0; padding-right: 0; max-width: 15%">
              <v-btn v-if="editedItem.headercheckbox" depressed @click="save()" color="#0A7EA5" dark class="mb-2">
                Add
              </v-btn>
              <!--  min="0" -->
              <v-text-field v-else v-model="editedItem.unit" ref="txtunit" label="Qty" type="number" dense outlined
                style="width: 90%"></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2">
              <!--   min="0" -->
              <v-text-field v-if="!editedItem.headercheckbox" v-model="editedItem.PricePerUnit" ref="txtPricePerUnit"
                label="Price per Unit" type="number" dense outlined style="width: 90%" @keydown.tab="save()"
                @keydown.enter="save()"></v-text-field>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3">
              <v-btn v-if="!editedItem.headercheckbox" depressed @click="save()" color="#0A7EA5" dark class="mb-2">
                Add
              </v-btn>
            </v-col>
          </v-row>
          <!-- v-if="editedItem.inv_title == 'Others'" -->
          <v-row>
            <v-col cols="12" sm="1" md="1"> </v-col>
            <v-col cols="12" sm="4" md="4" class="mt-n10">
              <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined
                label="Sevice/Description" persistent-hint hint="** ข้อมูลจะต่อจาก select ด้านบนที่เลือก ยกเว้น Others"
                class="hintcolorred"></v-text-field>
            </v-col>
            <v-col cols="12" sm="7" md="7"> </v-col>
          </v-row>
        </template>

        <template v-else>
          <v-row>
            <v-col cols="12" xl="1" lg="1" md="1" sm="1"></v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4">
              <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined
                label="Sevice/Description"></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2">
              <!--   min="0" -->
              <v-text-field v-model="editedItem.unit" ref="txtunit" label="Qty" type="number" dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2">
              <!--   min="0" -->
              <v-text-field v-model="editedItem.PricePerUnit" ref="txtPricePerUnit" label="Price per Unit" type="number"
                dense outlined @keydown.tab="save()" @keydown.enter="save()"></v-text-field>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
          </v-row>
        </template>
        <br />
      </div>
      <br />
      <v-row class="heightsize55formadvance">
        <v-col class="text-right" cols="12" md="7"> </v-col>
        <v-col class="mt-2 text-right" cols="12" md="2">Total : </v-col>
        <v-col class="text-right" cols="12" md="3">
          <v-row>
            <v-col cols="12" md="12">
              <v-row>
                <v-col class="text-right" cols="12" md="10">
                  <v-text-field reverse filled disabled outlined dense v-model="sumtotal"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogEdit" max-width="800px">
      <v-card class="pa-8">
        <v-card-title class="text-h6">Service No.{{ dataeditItem.no }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-textarea v-model="dataeditItem.description" multi-line outlined dense
                label="Service Details"></v-textarea>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <!--   min="0" -->
                <v-text-field type="number" label="Qty" @click="calserviceamount(dataeditItem)"
                  @keyup="calserviceamount(dataeditItem)" v-model="dataeditItem.unit" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field type="text" label="Price Per Unit" v-model="dataeditItem.PricePerUnit" outlined
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field type="text" label="Total Price" v-model="dataeditItem.amount" outlined dense
                  background-color="#F5F5F5" disabled></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveeditItem()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="closeeditItem()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialogInvoiceFreetext_So :status="dialogAddSo" :text_color="text_colorSo" :title="titleSo"
      :message="messageSo" />
  </v-container>
</template>

<script>
import SuccessDialogInvoiceFreetext_So from "@/components/cards/SuccessDialogInvoiceFreetext_So";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  name: "InvoiceSalseorderTab",
  props: [
    "so_id",
    "datainv_h",
    "datainv_so",
    "datainv_disable",
    "desserts",
    "cus_code",
    "vat_cus",
    "payment_term_cus",
    "po_no_cus",
    "attention_cus",
    "contact_position_cus",
    "vat_type_cus",
    "menurequest",
    "quotations_no",
  ],
  async beforeUpdate() {
    if (this.datainv_h.customerid != 0) {
      await this.loadDepartmentName();
      await this.loadCustomer();

      if (this.cus_code != "" && this.menurequest == "IM") {
        await this.loadinv_titlelist();
        await this.onSelectCustomerCodeChange(this.cus_code);
      }

      if (this.cus_code != "" && this.menurequest == "Litigations") {
        await this.loadinv_titlelist();
        await this.onSelectCustomerCodeChange(this.cus_code);
      }
      if (this.cus_code != "" && this.menurequest == "Incorporation") {
        await this.loadinv_titlelist();
        await this.onSelectCustomerCodeChange(this.cus_code);
      }
      if (this.cus_code != "" && this.menurequest == "Immigration") {
        await this.loadinv_titlelist();
        await this.onSelectCustomerCodeChange(this.cus_code);
      }
      //check appiont

      if (this.cus_code != "" && this.menurequest == "IP") {
        await this.onSelectCustomerCodeChange(this.cus_code);
        await this.loadip_pricelist();
      }
      if (this.department_name == "Immigration & Relocation") {
        await this.loadinv_titlelist();
      }
      //load add new freetext
      if (this.department_name == "Intellectual Property") {
        await this.loadip_pricelist();
      }
    }
  },
  async beforeMount() {
    await this.loadDepartmentName();
    await this.loadCustomer();

    if (this.cus_code != "" && this.menurequest == "IM") {
      await this.loadinv_titlelist();
      await this.onSelectCustomerCodeChange(this.cus_code);
    }
    if (this.cus_code != "" && this.menurequest == "Litigations") {
      await this.loadinv_titlelist();
      await this.onSelectCustomerCodeChange(this.cus_code);
    }
    if (this.cus_code != "" && this.menurequest == "Incorporation") {
      await this.loadinv_titlelist();
      await this.onSelectCustomerCodeChange(this.cus_code);
    }
    if (this.cus_code != "" && this.menurequest == "Immigration") {
      await this.loadinv_titlelist();
      await this.onSelectCustomerCodeChange(this.cus_code);
    }
    if (this.cus_code != "" && this.menurequest == "IP") {
      await this.onSelectCustomerCodeChange(this.cus_code);
      await this.loadip_pricelist();
      // this.desserts.push({headercheckbox: true,
      //   inv_title: "",
      //   description: `TO OUR CHARGES for professional service rendered to ${this.$route.query.customer_name_master} in connection with ${this.$route.query.company_name_master} ${this.$route.query.client_name_master}`,
      //   no: 1,
      //   unit:  "0",
      //   amount:  "0",
      //   PricePerUnit:  "0",})
      //   this.attention = this.$route.query.contact_master
    }
    if (this.department_name == "Immigration & Relocation") {
      await this.loadinv_titlelist();
    }
    if (this.department_name == "Intellectual Property") {
      await this.loadip_pricelist();
    }
  },
  async mounted() {
    this.$showLoader();
    await this.loadDepartmentName();
    await this.loadCustomer();
    if (this.cus_code != "" && this.menurequest == "IM") {
      await this.onSelectCustomerCodeChange(this.cus_code);
      await this.loadinv_titlelist();

      // this.desserts = [];
      if (
        this.desserts.length == 0 &&
        localStorage.getItem(server.COMPANYID) &&
        (localStorage.getItem(server.COMPANYID) == "1" ||
          localStorage.getItem(server.COMPANYID) == 1)
      ) {
        this.desserts.push({
          headercheckbox: true,
          inv_title: "",
          description: `TO OUR CHARGES for professional service rendered to ${this.$route.query.customer_name_master} in connection with ${this.$route.query.company_name_master} ${this.$route.query.client_name_master}`,
          no: 1,
          unit: "0",
          amount: "0",
          PricePerUnit: "0",
        });
      }
      this.attention = this.$route.query.contact_master;

    } else if (this.menurequest == "Litigations" || this.menurequest == "Incorporation" || this.menurequest == "Immigration") {
      await this.onSelectCustomerCodeChange(this.cus_code);
      await this.loadinv_titlelist();

      // ล้างแถวเดิมแบบ mutate (splice) แทนการ reassign props
      // เพื่อให้ parent เห็นการเปลี่ยนแปลงด้วย ไม่งั้นตอน Save ข้อมูลจะไม่ไป
      this.desserts.splice(0, this.desserts.length);

      if (
        localStorage.getItem(server.COMPANYID) &&
        (localStorage.getItem(server.COMPANYID) == "1" ||
          localStorage.getItem(server.COMPANYID) == 1)
      ) {
        this.desserts.push(
          {
            headercheckbox: true,
            inv_title: "",
            description: `Quotation No: ${this.quotations_no || ""}`,
            no: 1,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          },
          {
            headercheckbox: true,
            inv_title: "",
            description: `TO OUR CHARGES for professional service rendered to ${this.$route.query.customer_name_master} in connection with `,
            no: 2,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          }
        );
      }

      // แจ้ง parent ให้รับค่าล่าสุดทันที ไม่ต้องรอให้ผู้ใช้กด Add ก่อน
      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);


    } else if (this.menurequest == "IP") {
      this.cus_code = this.$route.params.customer_id;
      await this.onSelectCustomerCodeChange(this.cus_code);
      await this.loadip_pricelist();
      if (this.$route.query.description_inv && this.$route.query.price_inv) {
        this.desserts.push({
          headercheckbox: false,
          inv_title: "",
          description: this.$route.query.description_inv,
          no: 1,
          unit: "1",
          amount: this.$route.query.price_inv,
          PricePerUnit: this.$route.query.price_inv,
        });
      }
      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.desserts[this.editedIndex].unit = tolocalestringnumber(
        this.dataeditItem.unit
      );
    } else if (this.menurequest == "Docket") {
      await this.onSelectCustomerCodeChange(this.cus_code);
      await this.loadip_pricelist();

      // ---------------------------------------------------------
      // 0) CHECK: QUOTATION NO — ต้องอยู่บนสุดเสมอ
      // ---------------------------------------------------------
      const quotationKey = "quotation no:";
      const existsQuotation = this.desserts.some((item) =>
        (item.description || "").toString().toLowerCase().trim().startsWith(quotationKey)
      );

      if (!existsQuotation && this.quotations_no) {
        this.desserts.unshift({
          headercheckbox: true,
          inv_title: "",
          description: `Quotation No: ${this.quotations_no}`,
          no: 1,
          unit: "0",
          amount: "0",
          PricePerUnit: "0",
        });
      }

      // ---------------------------------------------------------
      // 1) CHECK: TO OUR CHARGES
      // ---------------------------------------------------------
      const targetChargesText =
        "TO OUR CHARGES for professional service rendered to".toLowerCase();

      // ค้นทั้ง array แทนการ fix ที่ index 0 เพราะตอนนี้แถว Quotation No อาจนำหน้าอยู่
      const existsCharges = this.desserts.some((item) =>
        (item.description || "").toString().toLowerCase().includes(targetChargesText)
      );

      if (!existsCharges) {
        this.desserts.push({
          headercheckbox: true,
          inv_title: "",
          description: `TO OUR CHARGES for professional service rendered to ${this.$route.query.customer_name_master} in connection with`,
          no: 1,
          unit: "0",
          amount: "0",
          PricePerUnit: "0",
        });
      }

      // ---------------------------------------------------------
      // 2) CHECK: YOUR REF (เลขที่อ้างอิงของลูกค้า)
      // ---------------------------------------------------------
      const yourRefText = this.$route.query.yourRef?.trim();

      // คีย์ที่ต้องขึ้นต้นแบบตรงตัว
      const yourRefKey1 = "your ref:";
      const yourRefKey2 = "เลขที่อ้างอิงของลูกค้า:";

      if (yourRefText !== "") {
        const existsYourRef = this.desserts.some((item) => {
          const desc = item.description.toString().toLowerCase().trim();

          // เช็คว่าเริ่มต้นด้วย key ทั้งสองแบบ
          return desc.startsWith(yourRefKey1) || desc.startsWith(yourRefKey2);
        });

        if (!existsYourRef) {
          this.desserts.push({
            headercheckbox: true,
            inv_title: "",
            description: yourRefText, // ใช้ค่าจริง
            no: 2,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          });
        }
      }

      // ---------------------------------------------------------
      // 3) CHECK: OUR REF (เลขที่อ้างอิงของบริษัท)
      // ---------------------------------------------------------

      const ourRefText = this.$route.query.ourRef?.trim().toLowerCase();

      // คีย์ที่ต้องขึ้นต้นแบบตรงตัว
      const keyEng = "our ref:";
      const keyThai = "เลขที่อ้างอิงของบริษัท:";

      // เช็คว่ามีรายการที่ขึ้นต้นด้วย 2 คำนี้หรือยัง
      const existsOurRef = this.desserts.some((item) => {
        const desc = item.description.toString().toLowerCase().trim();
        return desc.startsWith(keyEng) || desc.startsWith(keyThai);
      });

      if (!existsOurRef) {
        this.desserts.push({
          headercheckbox: true,
          inv_title: "",
          description: this.$route.query.ourRef, // << ตัวจริง
          no: 3,
          unit: "0",
          amount: "0",
          PricePerUnit: "0",
        });
      }

      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
    } else {
      if (this.cus_code != "") {
        await this.loadinv_titlelist();
        await this.onSelectCustomerCodeChangeelse(this.cus_code);
      }
    }
    if (this.department_name == "Immigration & Relocation") {
      await this.loadinv_titlelist();
    }
    if (this.department_name == "Intellectual Property") {
      await this.loadip_pricelist();
    }
    this.vat = this.vat_cus;
    this.payment_term = this.payment_term_cus;
    this.po_no = this.po_no_cus;
    // this.attention = this.attention_cus;

    this.$hideLoader();
  },
  components: {
    SuccessDialogInvoiceFreetext_So,
  },
  data() {
    return {
      sostatus: "",
      vat_type_list: [
        { id: "I", name: "Include Vat" },
        { id: "E", name: "Exclude Vat" },
      ],
      inv_title_list: [],
      po_no: "",
      attention: "",
      contact_position: "",
      vat_type: "",
      dialogAddSo: false,
      text_colorSo: "text-h5 green--text text-center",
      titleSo: "green",
      messageSo: "green",
      link: "",
      sumtotal: 0,
      editedItem: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      defaultItem: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      editedIndex: -1,
      dataeditItem: {
        no: 0,
        description: "",
        unit: 0,
        item_um: "",
        PricePerUnit: 0,
        amount: 0,
      },
      dialogEdit: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,
      customer: [],
      customer_list: [],
      customer_code: "",
      customer_id: "",
      customer_name: "",
      saleorder_id: "",
      currency: "",
      tax_id: "",
      branch: "",
      invoice_address: "",
      payment_term: "",
      vat: 0,
      vatCal: 0,
      // editedItem: {
      //   code: "",
      //   description: "",
      //   amount: 0,
      // },
      // dialogAdd: false,
      dialogSendMail: false,
      // text_color: "text-h5 green--text text-center",
      // title: "green",
      // message: "green",
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "9%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service Details",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "32%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "18%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Price Per Unit",
          value: "PricePerUnit",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Total Price",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          align: "center",
          width: "13%",
          divider: true,
          sortable: false,
        },
      ],
      department_name: "",
    };
  },
  methods: {
    async loadip_pricelist() {
      // const result = await api.getIPPriceListForInvSo();
      const result = await api.billing_expense_getInvTitleByDep(
        localStorage.getItem(server.DEPARTMENT_ID)
      );
      this.inv_title_list = result.data;
      this.inv_title_list.push({ title: "Others", price: 0 });
    },
    async loadDepartmentName() {
      const result = await api.billing_expense_getDepartmentByID(
        localStorage.getItem(server.DEPARTMENT_ID)
      );
      this.department_name = result.data[0].name;
    },
    async loadinv_titlelist() {
      const result = await api.billing_expense_getInvTitleByDep(
        localStorage.getItem(server.DEPARTMENT_ID)
      );

      this.inv_title_list = result.data;
      this.inv_title_list.push({ title: "Others", price: 0 });
    },
    async onSelectHeaderChange(headercheckbox) {
      this.editedItem.unit = 0;
      this.editedItem.PricePerUnit = 0;
    },
    async onSelectmiscellaneous_disbursementsChange(inv_title) {
      this.inv_title_list.filter((item) => {
        if (item.title == inv_title) {
          this.editedItem.unit = 1;
          this.editedItem.PricePerUnit = item.price;
        }
      });
    },
    save() {
      if (this.editedItem.headercheckbox) {
        this.editedItem.unit = 0;
        this.editedItem.PricePerUnit = 0;
      } else {
      }
      if (this.customer_code == "") {
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณาเลือก Client",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        !this.editedItem.headercheckbox &&
        (this.editedItem.unit == undefined ||
          this.editedItem.unit == "0" ||
          this.editedItem.unit == 0)
      ) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Qty",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (!this.editedItem.headercheckbox && !this.editedItem.unit) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_global_dialog_invoicefreetext_sodialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Qty",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (
        !this.editedItem.headercheckbox &&
        (this.editedItem.PricePerUnit == undefined ||
          this.editedItem.PricePerUnit == "0" ||
          this.editedItem.PricePerUnit == 0)
      ) {
        // alert("กรุณากรอกจำนวนเงินต่อหน่วย");
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Price Per Unit",
          "text-h5 red--text text-center"
        );
        this.$refs["txtPricePerUnit"].focus();
        return;
      }

      if (this.editedItem.PricePerUnit < 0) {
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "จำนวน Price Per Unit ต้องมากกว่า 0",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (
        (this.$route.params.customer_id ||
          this.menurequest == "IM" ||
          this.menurequest == "Litigations" ||
          this.menurequest == "Incorporation" ||
          this.menurequest == "Immigration" ||
          this.menurequest == "IP" ||
          this.department_name == "Immigration & Relocation" ||
          this.department_name == "Intellectual Property") &&
        this.editedItem.inv_title !== "Others"
      ) {
        if (this.editedItem.inv_title == "") {
          this.$store.state.global_dialog_invoicefreetext_so = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "กรุณาเลือก select invoice title",
            "text-h5 red--text text-center"
          );
          return;
        }
        this.editedItem.description =
          this.editedItem.inv_title +
          (this.editedItem.description != "" ||
            this.editedItem.description != undefined ||
            this.editedItem.description != null
            ? this.editedItem.description
            : "");
      } else {
      }
      if (
        this.editedItem.inv_title == "Others" &&
        (this.editedItem.description == "" ||
          this.editedItem.description == null)
      ) {
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอก Description/Service",
          "text-h5 red--text text-center"
        );
        this.$refs["txtDescription"].focus();
        return;
      }

      // if (this.editedIndex > -1) {
      //   Object.assign(this.desserts[this.editedIndex], this.editedItem);
      // } else {
      // this.desserts.push(this.editedItem);
      // }
      if (this.desserts.length == 0) {
        this.desserts.push(this.editedItem);
      } else {
        let getolddesserts = [];
        for (let i = 0; i < this.desserts.length; i++) {
          if (this.editedItem.unit == 0 && this.editedItem.PricePerUnit == 0) {
            if (
              stringcommatonumber(this.desserts[i].unit.toString()) > 0 &&
              stringcommatonumber(this.desserts[i].PricePerUnit.toString()) > 0
            ) {
              getolddesserts = [
                ...this.desserts.slice(0, i),
                this.editedItem,
                ...this.desserts.slice(i),
              ];
              this.desserts = getolddesserts;
              break;
            } else {
              if (i == this.desserts.length - 1) {
                this.desserts.push(this.editedItem);
                break;
              }
            }
          } else {
            this.desserts.push(this.editedItem);
            break;
          }
        }
      }

      this.sumtotal = 0;

      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      // this.sumtotal = tolocalestringnumber(this.sumtotal);
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.close();
      this.$refs["txtDescription"].focus();
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async loaddataSO() {
      this.$showLoader();
      if (this.datainv_h.customerid != 0) {
        this.customer_code = this.datainv_h.customer_code;
        this.customer_id = this.datainv_h.customerid;
        this.customer_name = this.datainv_h.customer_name;
        this.saleorder_id = this.datainv_h.saleorder_id;
        this.currency = this.datainv_h.currency;
        this.invoice_address = this.datainv_h.customer_address;
        this.payment_term = this.datainv_h.customer_paymentterm;
        this.branch = this.datainv_h.customer_paymentterm;
        this.tax_id = this.datainv_h.customer_taxid;
        this.vat = this.datainv_h.customer_vat;
        this.vatCal = this.datainv_h.customer_vat;

        if (
          this.datainv_so.length > 0 &&
          localStorage.getItem(server.COMPANYID) &&
          (localStorage.getItem(server.COMPANYID) == "1" ||
            localStorage.getItem(server.COMPANYID) == 1)
        ) {
          this.desserts.unshift({
            headercheckbox: true,
            inv_title: "",
            description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
            no: 1,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          });
          this.desserts = this.datainv_so;
          let testsumso = 0;
          this.sumtotal = 0;
          this.desserts.forEach((item, index) => {
            item.no = index + 1;
            item.unit = stringcommatonumber(item.unit.toString());
            item.PricePerUnit = stringcommatonumber(
              item.PricePerUnit.toString()
            );
            item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
            this.sumtotal += parseFloat(item.amount, 10);
            item.unit = tolocalestringnumber(item.unit);
            item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
            item.amount = tolocalestringnumber(item.amount);
          });
          this.sumtotal = this.sumtotal.toFixed(2);
          this.$store.state.inv_so_total = this.sumtotal;
          this.$emit("inv_sotab_isheader", this.sumtotal);
          this.$emit("inv_sotab_tabledesserts", this.desserts);
        } else {
          let testsumso = 0;
          this.$emit("inv_sotab_isheader", testsumso);
          this.$emit("inv_sotab_tabledesserts", this.desserts);
        }
        this.$hideLoader();
      } else {
        const res_h = await api.getAllSOById(this.so_id);
        const res_d = await api.getAlldetailSOById(this.so_id);

        if (res_h.data.length > 0) {
          let dataso_h = res_h.data[0];
          this.customer_code = dataso_h.customer_code;
          this.customer_id = dataso_h.customer_id;
          this.customer_name = dataso_h.name;
          this.invoice_address = dataso_h.customer_inv_address;
          this.payment_term = dataso_h.payment_term;
          this.branch = dataso_h.branch;
          this.vat = dataso_h.vat;
          this.vatCal = dataso_h.sum_tax;
          this.tax_id = dataso_h.tax_id;
        }
        let testsumso = 0;
        this.desserts = res_d.data;
        this.sumtotal = 0;
        this.desserts.forEach((item, index) => {
          item.no = index + 1;
          item.unit = stringcommatonumber(item.unit.toString());
          item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
          item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
          this.sumtotal += parseFloat(item.amount, 10);
          item.unit = tolocalestringnumber(item.unit);
          item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
          item.amount = tolocalestringnumber(item.amount);
        });
        this.sumtotal = this.sumtotal.toFixed(2);

        this.$emit(
          "inv_sotab_noheader",
          this.customer_id,
          this.invoice_address,
          this.tax_id,
          this.branch,
          this.payment_term,
          this.vat,
          testsumso,
          res_h.data[0].id
        );
        this.$store.state.inv_so_total = this.sumtotal;
        this.$emit("inv_sotab_isheader", this.sumtotal);
        this.$emit("inv_sotab_tabledesserts", this.desserts);
        this.$hideLoader();
      }
    },

    async openeditItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dataeditItem.no = item.no;
      this.dataeditItem.description = item.description;
      this.dataeditItem.unit = item.unit;
      this.dataeditItem.item_um = item.item_um;
      this.dataeditItem.PricePerUnit = stringcommatonumber(
        item.PricePerUnit.toString()
      );
      this.dataeditItem.amount = item.amount;
      this.dialogEdit = true;
    },
    async saveeditItem() {
      // alert(this.desserts[this.editedIndex].unit);
      this.desserts[this.editedIndex].description =
        this.dataeditItem.description;
      this.desserts[this.editedIndex].unit = this.dataeditItem.unit;
      this.desserts[this.editedIndex].PricePerUnit =
        this.dataeditItem.PricePerUnit;
      this.desserts[this.editedIndex].amount = this.dataeditItem.amount;
      let testsumso = 0;
      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.desserts[this.editedIndex].unit = tolocalestringnumber(
        this.dataeditItem.unit
      );
      this.dialogEdit = false;
    },
    async closeeditItem() {
      this.dialogEdit = false;
    },
    async calserviceamount(item) {
      this.dataeditItem.amount = parseFloat(
        this.dataeditItem.unit *
        stringcommatonumber(this.dataeditItem.PricePerUnit)
      );
      this.dataeditItem.amount = tolocalestringnumber(this.dataeditItem.amount);
    },
    async loadCustomer() {
      let result = [];
      result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });

      this.customer = result.data;

      this.customer.forEach((item) => {
        item.invoice_address = `${item.address_invoice} ${item.province_invoice} ${item.country_invoice} ${item.zipcode_invoice}`;
      });
      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });
    },

    async onSelectCustomerCodeChangef(code) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.cust_account === code);
      this.customer_name = tmp[0].name;
      this.customer_address = tmp[0].address;
      this.invoice_address = tmp[0].invoice_address;
      this.payment_term = tmp[0].payment_term;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.po_no = tmp[0].po_no;
      this.attention = tmp[0].attention;
      this.contact_position = tmp[0].contact_position;
      this.vat_type = tmp[0].vat_type;
      this.vat = tmp[0].vat;
      this.vatCal = tmp[0].vat;
      this.currency = tmp[0].currency;
      this.$emit("inv_sotab_customer", tmp[0]);
      this.$emit("inv_sotab_vat", this.vatCal);
    },
    async onSelectCustomerCodeChangeelse(code) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.cust_account === code);
      this.customer_name = tmp[0].name;
      this.customer_address = tmp[0].address;
      this.invoice_address = tmp[0].invoice_address;
      // this.payment_term = tmp[0].payment_term;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      // this.vat = tmp[0].vat;
      this.vatCal = tmp[0].vat;
      this.currency = tmp[0].currency;

      this.vat = this.vat_cus;
      this.payment_term = this.payment_term_cus;
      this.po_no = this.po_no_cus;
      this.attention = this.attention_cus;
      this.contact_position = this.contact_position_cus;
      this.vat_type = this.vat_type_cus;

      this.$emit("inv_sotab_customer", tmp[0]);
      this.$emit("inv_sotab_vat", this.vatCal);
      this.$emit("inv_sotab_vatcus", this.vat);
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      this.$emit("inv_sotab_ponocus", this.po_no);
      this.$emit("inv_sotab_attentioncus", this.attention);
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
      this.$emit("inv_sotab_vat_type", this.vat_type);
    },
    async onSelectCustomerCodeChange(code) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.cust_account === code);

      this.customer_name = tmp[0].name;
      this.customer_address = tmp[0].address;
      this.invoice_address = tmp[0].invoice_address;
      this.payment_term = tmp[0].payment_term;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.attention = tmp[0].contact_name;
      this.contact_position = tmp[0].contact_position;
      this.vat_type = tmp[0].vat_type;
      this.vat = tmp[0].vat;
      this.vatCal = tmp[0].vat;
      this.currency = tmp[0].currency;
      this.$emit("inv_sotab_customer", tmp[0]);
      this.$emit("inv_sotab_vat", this.vatCal);
      this.$emit("inv_sotab_vatcus", this.vat);
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      this.$emit("inv_sotab_ponocus", this.po_no);
      this.$emit("inv_sotab_attentioncus", this.attention);
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
      this.$emit("inv_sotab_vat_type", this.vat_type);

      const isCompanyOne =
        localStorage.getItem(server.COMPANYID) &&
        (localStorage.getItem(server.COMPANYID) == "1" ||
          localStorage.getItem(server.COMPANYID) == 1);

      if (!isCompanyOne) return;

      const chargesKey = "to our charges for professional service rendered to";
      const newChargesRow = {
        headercheckbox: true,
        inv_title: "",
        description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
        no: 1,
        unit: "0",
        amount: "0",
        PricePerUnit: "0",
      };

      // หาแถว TO OUR CHARGES จากตำแหน่งจริง ไม่ fix ว่าต้องเป็น index 0
      // เพราะอาจมีแถว "Quotation No:" นำหน้าอยู่ (เคส Litigations/Incorporation/Immigration)
      const chargesIndex = this.desserts.findIndex((item) =>
        (item.description || "").toString().toLowerCase().includes(chargesKey)
      );

      if (chargesIndex > -1) {
        // มีอยู่แล้ว -> อัปเดตชื่อลูกค้าในแถวเดิม ไม่ต้องลบ/เพิ่มใหม่
        this.desserts.splice(chargesIndex, 1, newChargesRow);
      } else {
        // ยังไม่มี -> เพิ่มต่อท้ายแถวอ้างอิง (Quotation No) ถ้ามี
        const quotationIndex = this.desserts.findIndex((item) =>
          (item.description || "").toString().toLowerCase().trim().startsWith("quotation no:")
        );
        if (quotationIndex > -1) {
          this.desserts.splice(quotationIndex + 1, 0, newChargesRow);
        } else {
          this.desserts.unshift(newChargesRow);
        }
      }

      // เรียงเลขลำดับใหม่ + แจ้ง parent
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
      });
      this.$emit("inv_sotab_tabledesserts", this.desserts);
    },
    onSelectCustomerChange(search_customer) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.name === search_customer);
      this.invoice_address = tmp[0].invoice_address;
      this.payment_term = tmp[0].payment_term;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.vat = tmp[0].vat;
      this.vatCal = tmp[0].vat;
      // this.po_no = tmp[0].po_no;
      this.attention = tmp[0].contact_name;
      this.contact_position = tmp[0].contact_position;
      this.vat_type = tmp[0].vat_type;
      this.currency = tmp[0].currency;
      this.$emit("inv_sotab_customer", tmp[0]);
      this.$emit("inv_sotab_vat", this.vatCal);

      this.$emit("inv_sotab_vatcus", this.vat);
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      this.$emit("inv_sotab_ponocus", this.po_no);
      this.$emit("inv_sotab_attentioncus", this.attention);
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
      this.$emit("inv_sotab_vat_type", this.vat_type);
      if (
        this.desserts.length == 0 &&
        localStorage.getItem(server.COMPANYID) &&
        (localStorage.getItem(server.COMPANYID) == "1" ||
          localStorage.getItem(server.COMPANYID) == 1)
      ) {
        this.desserts.push({
          headercheckbox: true,
          inv_title: "",
          description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
          no: 1,
          unit: "0",
          amount: "0",
          PricePerUnit: "0",
        });
      } else if (
        this.desserts.length == 1 &&
        localStorage.getItem(server.COMPANYID) &&
        (localStorage.getItem(server.COMPANYID) == "1" ||
          localStorage.getItem(server.COMPANYID) == 1)
      ) {
        if (
          this.desserts[0].description
            .toString()
            .toLowerCase()
            .includes(
              "TO OUR CHARGES for professional service rendered to".toLowerCase()
            ) === true
        ) {
          this.desserts.splice(0, 1);
          this.desserts.unshift({
            headercheckbox: true,
            inv_title: "",
            description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
            no: 1,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          });
        } else {
          if (
            localStorage.getItem(server.COMPANYID) &&
            (localStorage.getItem(server.COMPANYID) == "1" ||
              localStorage.getItem(server.COMPANYID) == 1)
          ) {
            this.desserts.unshift({
              headercheckbox: true,
              inv_title: "",
              description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
              no: 1,
              unit: "0",
              amount: "0",
              PricePerUnit: "0",
            });
          }
        }
      } else if (
        this.desserts.length > 1 &&
        localStorage.getItem(server.COMPANYID) &&
        (localStorage.getItem(server.COMPANYID) == "1" ||
          localStorage.getItem(server.COMPANYID) == 1)
      ) {
        if (
          this.desserts[0].description
            .toString()
            .toLowerCase()
            .includes(
              "TO OUR CHARGES for professional service rendered to".toLowerCase()
            ) === true
        ) {
          this.desserts.splice(0, 1);
          this.desserts.unshift({
            headercheckbox: true,
            inv_title: "",
            description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
            no: 1,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          });
        } else {
          if (
            localStorage.getItem(server.COMPANYID) &&
            (localStorage.getItem(server.COMPANYID) == "1" ||
              localStorage.getItem(server.COMPANYID) == 1)
          ) {
            this.desserts.unshift({
              headercheckbox: true,
              inv_title: "",
              description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
              no: 1,
              unit: "0",
              amount: "0",
              PricePerUnit: "0",
            });
          }
        }
      } else {
      }
    },
    async onSelectvat() {
      this.$emit("inv_sotab_vatcus", this.vat);
    },
    async onSelectpayment() {
      this.$emit("inv_sotab_paymentcus", this.payment_term);
    },
    async onSelectPONO() {
      this.$emit("inv_sotab_ponocus", this.po_no);
    },
    async onSelectattention() {
      this.$emit("inv_sotab_attentioncus", this.attention);
    },
    async onSelectcontact_position() {
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
    },
    async onSelectvat_type() {
      this.$emit("inv_sotab_vat_type", this.vat_type);
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dialogDelete = true;
    },
    deleteItemConfirm(indexno) {
      this.desserts.splice(this.editedIndex, 1);
      let testsumso = 0;
      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.dialogDelete = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setupAlertDialog(status, titleSo, messageSo, text_colorSo) {
      this.titleSo = titleSo;
      this.messageSo = messageSo;
      this.dialogAddSo = status;
      this.text_colorSo = text_colorSo;
    },
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.heightsize55formadvance {
  /* height: 55px; */
}
</style>